var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAccEditar(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "17px",
    height: "17px",
    viewBox: "0 0 17 17",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "12.1 AccEditar") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "FACTURACION",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "4.1-Series",
    transform: "translate(-1321.000000, -358.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "F1",
    transform: "translate(266.000000, 329.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-7",
    transform: "translate(1056.000000, 28.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "12.1-AccEditar",
    transform: "translate(0.000000, 1.672416)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.0067044,8.32404787 L14.0067044,13.2260451 C14.0067044,14.3867445 13.065865,15.3275839 11.9055333,15.3275839 L2.1011711,15.3275839 C0.940839344,15.3275839 0,14.3867445 0,13.2260451 L0,3.42205062 C0,2.2613512 0.940839344,1.32051186 2.1011711,1.32051186 L7.00316836,1.32051186",
    id: "Stroke-1",
    stroke: "#000000",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.72443128,10.2005426 L6.12700455,10.2005426 L6.12700455,7.60311584 L12.5172848,0.538018487 C13.2346428,-0.179339496 14.3976323,-0.179339496 15.1149902,0.538018487 C15.8323482,1.25537647 15.8323482,2.41808723 15.1149902,3.13544521 L8.72443128,10.2005426 Z",
    id: "Fill-3",
    fill: "#000000"
  }))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccEditar);
export default __webpack_public_path__ + "static/media/AccEditar.f74c5d9a1f7464c3ba5d6f7654d871ba.svg";
export { ForwardRef as ReactComponent };